/**
 * 「最近查看过的任务」（Messages 插入任务的默认列表，对齐 mobile）：打开任务详情时记下任务 id，
 * 存本机 localStorage，按用户分键，最多 30 条（新的在前，重复的挪到最前），主动退出登录时清。
 * 只存 id：标题 / 状态等显示时按 id 一次批量取（按当前权限，看不到的就不列）。
 * localStorage 不可用时照常工作，只是不记。写法同全局搜索的 recent.ts。
 */
import { isDeliberateSignOut } from '@/utils/authEvents'

const PREFIX = 'chat:recentTasks:'
export const MAX_RECENT_TASKS = 30

export function readRecentTasks(userId: string | null | undefined): string[] {
  if (!userId) return []
  try {
    const raw = localStorage.getItem(PREFIX + userId)
    const parsed: unknown = raw ? JSON.parse(raw) : []
    if (!Array.isArray(parsed)) return []
    const out: string[] = []
    for (const v of parsed) {
      if (typeof v === 'string' && /^\d+$/.test(v) && !out.includes(v)) out.push(v)
    }
    return out.slice(0, MAX_RECENT_TASKS)
  } catch {
    return []
  }
}

export function pushRecentTask(userId: string | null | undefined, taskId: string | null | undefined): void {
  if (!userId || !taskId || !/^\d+$/.test(taskId)) return
  const current = readRecentTasks(userId)
  if (current[0] === taskId) return
  const next = [taskId, ...current.filter((id) => id !== taskId)].slice(0, MAX_RECENT_TASKS)
  try {
    localStorage.setItem(PREFIX + userId, JSON.stringify(next))
  } catch {
    // 存不了（隐私模式、配额满）就不记
  }
}

export function clearAllRecentTasks(): void {
  try {
    const keys: string[] = []
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key?.startsWith(PREFIX)) keys.push(key)
    }
    keys.forEach((key) => localStorage.removeItem(key))
  } catch {
    // 同上
  }
}

// 主动退出才清；401（会话过期）后通常是同一个人重新登录，留着
if (typeof window !== 'undefined') {
  window.addEventListener('auth:unauthorized', (event) => {
    if (isDeliberateSignOut(event)) clearAllRecentTasks()
  })
}
